<span [ngSwitch]="log?.action">

    <span *ngSwitchCase="'Unpaired'">
      {{ 'DEVICE_WAS_UNPAIRED' | translate }} 
    </span>
  
    <span *ngSwitchCase="'Erased'">
      {{ 'DEVICE_WAS_ERASED' | translate }} 
    </span>

    <span *ngSwitchCase="'Replaced'">
      {{ 'DEVICE_REPLACED' | translate : { targetName: log?.details?.deviceChanges?.deviceName || log?.details?.targetName, targetId: log?.details?.deviceChanges?.deviceId || log?.details?.targetId } }} 
    </span>

    <span *ngSwitchCase="'Modify'">
      {{ $safeNavigationMigration(log?.details?.translationCode) | translate : { targetName: log?.details?.targetName, targetId: log?.details?.targetId } }}
      <a [routerLink]="['/device', $safeNavigationMigration(log?.details?.targetId)]" (click)="closeDialog.emit()">
        {{ $safeNavigationMigration(log?.details?.targetName) | identityFormat : $safeNavigationMigration(log?.details?.targetId) }}
      </a>
    </span>
  
    <span *ngSwitchDefault>
      {{ $safeNavigationMigration(log?.action) | uppercase }} 
    </span>
  
    <strong *ngIf="!log?.staffId && log?.staffName === 'Everon Admin'; else elseBlock">
        Everon
      </strong>
  
      <ng-template #elseBlock>
        <a [routerLink]="['/staff', $safeNavigationMigration(log?.staffId)]" (click)="closeDialog.emit()">
          {{ $safeNavigationMigration(log?.staffName) | identityFormat : $safeNavigationMigration(log?.staffId) }}
        </a>
      </ng-template>
  
  </span>
  
  <p class="mt-1">{{ $safeNavigationMigration(log?.timestamp) | moment : "l LTS" }}</p>
  
  <hr />
  
  <div class="details-box">
  <div class="container">
  
    <!-- Device name -->
    <span class="item-title">{{ "DEVICE_NAME" | translate }}:</span>
    <div class="item-pair-value">
      <span [ngClass]="{
        'negative-highlight line-through': log?.action === 'Unpaired' || log?.action === 'Erased'
      }">
        {{ log?.details?.deviceChanges?.deviceName 
          || log?.details?.targetName 
          || ('NONE' | translate) }}
      </span>
    </div>
  
    <!-- Serial number -->
    <span class="item-title">{{ "SERIAL_NUMBER" | translate }}:</span>
    <div class="item-pair-value">
      <ng-container *ngIf="log?.details?.translationCode === 'DEVICE_REPLACED'; else defaultSerialNumber">
        <span class="negative-highlight line-through">
          {{ log?.details?.deviceChanges?.deviceId || log?.details?.targetId || ('NONE' | translate) }}
        </span>
        <i class="fa-light fa-arrow-right-long fa-lg"></i>
        <span class="positive-highlight">
          {{ log?.details?.deviceChanges?.replacedWithDeviceId || ('NONE' | translate) }}
        </span>
      </ng-container>
      <ng-template #defaultSerialNumber>
        <span [ngClass]="{
          'negative-highlight line-through': log?.action === 'Unpaired' || log?.action === 'Erased'
        }">
          {{ log?.details?.deviceChanges?.deviceId
            || log?.details?.targetId
            || ('NONE' | translate) }}
        </span>
      </ng-template>
    </div>
  
    <!-- Device type -->
    <ng-container *ngIf="log?.details?.translationCode !== 'DOOR_ID_OVERRIDE'">
      <span class="item-title">{{ "DEVICE_TYPE" | translate }}:</span>
      <div class="item-pair-value">
        <span [ngClass]="{
          'negative-highlight line-through': log?.action === 'Unpaired' || log?.action === 'Erased'
        }">
        {{ getDeviceTypeName($safeNavigationMigration(log?.details?.deviceChanges?.deviceType)) }}
        </span>
      </div>
    </ng-container>

    <!-- Removed activations (for device replacement) -->
    <span
      *ngIf="getRemovedActivationEntries().length"
      class="item-title"
    >{{ "ACTIVATIONS" | translate }}:</span>
    <div
      *ngIf="getRemovedActivationEntries().length"
      class="item-pair-value removed-activation-list"
    >
      <div
        *ngFor="let item of getRemovedActivationEntries()"
        class="negative-highlight removed-activation-item"
      >
        <span *ngIf="item.routeLabel">{{ item.routeLabel }}: </span>
        <span class="line-through">{{ item.activation }}</span>
      </div>
    </div>

    <!-- Door ID change -->
    <ng-container *ngIf="log?.details?.translationCode === 'DOOR_ID_OVERRIDE'">
      <span class="item-title">{{ "DOOR_ID" | translate }}:</span>
      <div class="item-pair-value">
        <span class="negative-highlight line-through">{{ log?.details?.deviceChanges?.defectiveDoorId ?? ('NONE' | translate) }}</span>
        <i class="fa-light fa-arrow-right-long fa-lg"></i>
        <span class="positive-highlight">{{ log?.details?.deviceChanges?.newDoorId ?? ('NONE' | translate) }}</span>
      </div>
    </ng-container>
  </div>
  </div>